export default "__VITE_ASSET__DkLx_8ir__"